<script setup lang="ts">
import { computed } from 'vue'
import { ALL_COUNTRIES } from '@/types/countries'

const props = defineProps<{
  /** ISO 3166-1 alpha-2 country code, or null/empty when unknown. */
  code: string | null | undefined
}>()

const normalizedCode = computed(() => (props.code ?? '').trim().toUpperCase())

const countryName = computed(() => {
  const match = ALL_COUNTRIES.find((c) => c.code === normalizedCode.value)
  return match ? match.name : normalizedCode.value
})

const flagClass = computed(() => `fi fi-${normalizedCode.value.toLowerCase()}`)
</script>

<template>
  <!-- Fixed-width wrapper keeps names aligned when a flag is missing -->
  <span class="inline-block w-6 mr-2 align-middle shrink-0" data-testid="country-flag-slot">
    <span
      v-if="normalizedCode"
      :class="flagClass"
      role="img"
      :aria-label="countryName"
      :title="countryName"
      data-testid="country-flag"
    />
  </span>
</template>
